import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiBaseUrlService {
  private readonly resolvedAspNetBaseUrl = this.resolveAspNetBaseUrl();
  private readonly resolvedNodeBaseUrl = this.resolveNodeBaseUrl();

  getBaseUrl(): string {
    return this.getAspNetBaseUrl();
  }

  getAspNetBaseUrl(): string {
    return this.resolvedAspNetBaseUrl;
  }

  getNodeBaseUrl(): string {
    return this.resolvedNodeBaseUrl;
  }

  private resolveAspNetBaseUrl(): string {
    if (typeof globalThis.window === 'undefined') {
      return environment.baseUrl;
    }

    const hostname = globalThis.window.location.hostname.toLowerCase();

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return environment.baseUrl || 'http://localhost:5005/api';
    }

    if (hostname.includes('staging') || hostname.includes('stage')) {
      return environment.baseUrl || 'https://apistaging.askiitians.com/api';
    }

    return environment.baseUrl || 'https://prodapi.askiitians.com/api';
  }

  private resolveNodeBaseUrl(): string {
    const configuredNodeBaseUrl = (environment as any).nodeBaseUrl || '';

    if (typeof globalThis.window === 'undefined') {
      return configuredNodeBaseUrl || 'http://localhost:4000/api';
    }

    const hostname = globalThis.window.location.hostname.toLowerCase();

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return configuredNodeBaseUrl || 'http://localhost:4000/api';
    }

    if (configuredNodeBaseUrl) {
      return configuredNodeBaseUrl;
    }

    return this.resolvedAspNetBaseUrl;
  }
}
